import React, {useEffect , useState } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";
import { Box, Grid } from "@mui/material";
import { makeStyles } from "@material-ui/core/styles";
import * as Actions from "../../store/action/policy";
import Skeleton from '@mui/material/Skeleton';
import getDateFromString from "../../utils/getDateFromString"
import {getLabelClass, renderInputOrSpan} from "../../utils/formUtils";
import {toggleExpansion} from "../../utils/toggleExpansion";
import {translatePolicyRole} from "../../utils/translatePolicyRole";
import {translatePolicyType} from "../../utils/translatePolicyType";

const useStyles = makeStyles((theme) => ({
  labelInput: {
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    textAlign: "left",
    color: "rgba(70, 78, 95, 1)",
    marginBottom: "10px",
  },
  styleInput: {
    borderRadius: "4px",
    border: 0,
    background: "rgba(243, 246, 249, 1)",
    height: "36px",
    width: "241px",
    padding: "14px",
    fontFamily: "Poppins",
    fontSize: "12px",
    fontWeight: 400,
    lineHeight: "18px",
    textAlign: "left",
    color: "rgba(70, 78, 95, 1)",
  },
  paper: {
    width: "100%",
    boxShadow: "0px 4px 4px 0px rgba(0, 0, 0, 0.06)",
  },

  customAccordionItem : {
    width: "100%",
    marginBottom: "20px",
    borderRadius: "11px",
    border:`1px solid rgba(187, 200, 8, 1)`,

    },
  expanded: {
    border: "none",
  },
  styleSpan:{
    color: 'rgba(70, 78, 95, 1)',
    fontSize: '12px',
    fontWeight: 400,
    fontFamily: 'Poppins'
  },
  styleSpanLabel:{
    color: 'rgba(70, 78, 95, 1)',
    fontSize: '12px',
    fontWeight: 600,
    fontFamily: 'Poppins'
  }
}));

function PoliceSection( props ) {
  const classes = useStyles();
  const listOfPolice = props.listOfPolice ; 
  const [policy, setPolicy] = useState([]);  
  const [loading, setLoading] = useState(true);
  const renderAsSpans = props.renderAsSpans 
  const [expandedItems, setExpandedItems] = useState(new Set([0]));

  const getWaranties= (subscribedWaranties) => {  
    const Waranties =  subscribedWaranties?.map(waranties => waranties.coverage?.label+" ")
    return Waranties
  }

  const getPolicy = async (policys ) => {
    
    try {
       const policyDetails = await Promise.all(policys.map(policyUid => Actions.getPolicyDetails(policyUid)));
      return policyDetails; 
    } catch (error) {
      console.error(`Error fetching Policy: ${error}`);
      return [];
    }
  };
 

  const fetchPolicy = async () => {
    setLoading(true);
 console.log('Fetching Policy:' ,listOfPolice)
    const policyData = await getPolicy(listOfPolice.map(policy => policy.policyUid)); 
    
    const filteredPolicy = policyData.filter(item => item !== undefined);
    filteredPolicy.forEach((policy) => {
      const matchingPolicy = listOfPolice.find((p) => p.policyUid === policy.policyNumber  );
      if (matchingPolicy) {
        localStorage.setItem('currentPolicy', matchingPolicy);
        policy.rolePolicy = matchingPolicy.role;
      }
    });
    setPolicy(Array.isArray(filteredPolicy) ? filteredPolicy : [filteredPolicy]);
    setLoading(false);
  }; 
  useEffect(() => {
   
    fetchPolicy();
  }, []);


  return (
    <div style={{ padding: "40px" }}>
      <Accordion defaultIndex={[0]}    allowMultiple >
      {loading ? 
      <>
      {[...Array(3)].map((row, index) => {
        return (
            <AccordionItem className={`${classes.customAccordionItem} ${renderAsSpans ? classes.expanded : ''}`} key={index}>
              <AccordionButton
                  onClick={() => toggleExpansion(index, expandedItems, setExpandedItems)}
                  style={{ height: "47px", border: "none", background: "rgba(249, 249, 249, 1)", padding: "10px", borderRadius: "11px" }}  >
            <AccordionIcon size="30px" style={{ backgroundColor: "rgba(240, 243, 199, 1)", width: "25px", height: "25px", borderRadius: "5px", color: "rgba(187, 200, 8, 1)" }} />
            <Skeleton  size="30px" animation="wave" width={160} height={30}/>
          </AccordionButton>
          <AccordionPanel style={{ width: "100%", background: 'rgba(255, 255, 255, 1)', padding: '30px' , borderRadius: "11px" }}>
          <Grid container style={{justifyContent: 'start' , marginBottom :'10px'}}  spacing={2} >
                  <Grid item  > 
                      <div>
                        <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>N° Police</div>
                        <Skeleton animation="wave" width={241} height={50}/>
                      </div>
                  </Grid>
                  <Grid item  > 
                      <div>
                        <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Date effet</div>
                        <Skeleton animation="wave" width={241} height={50}/>
                      </div>
                  </Grid>
                  <Grid item  > 
                      <div>
                        <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Date expiration</div>
                        <Skeleton animation="wave" width={241} height={50}/>
                      </div>
                  </Grid>
                  <Grid item  > 
                      <div>
                        <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Usage</div>
                        <Skeleton animation="wave" width={241} height={50}/>
                      </div>
                  </Grid>
                  
           
      
                  <Grid item  > 
                    <div>
                    <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Type</div>
                    <Skeleton animation="wave" width={241} height={50}/>
                    </div>
                  </Grid>
                  <Grid item   > 
                    <div >
                      <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Agence</div>
                      <Skeleton animation="wave" width={241} height={50}/>
                    </div>
                  </Grid>
                  <Grid item > 
                    <div   >
                      <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Liste de garanties</div>
                      <Skeleton animation="wave" width={241} height={50}/>
                    </div>
                  </Grid>
                   
          </Grid>
            
          </AccordionPanel>
        </AccordionItem>
        )})}
        </>
        :
       <>
       {policy.map((police, index) => (

           <AccordionItem className={`${classes.customAccordionItem} ${renderAsSpans ? classes.expanded : ''}`} key={index}>
             <AccordionButton
                 onClick={() => toggleExpansion(index, expandedItems, setExpandedItems)}
                 style={{ height: "47px", border: "none", background: "rgba(249, 249, 249, 1)", padding: "10px", borderRadius: "11px" }}  >
                  <AccordionIcon size="30px" style={{ backgroundColor: "rgba(240, 243, 199, 1)", width: "25px", height: "25px", borderRadius: "5px", color: "rgba(187, 200, 8, 1)" }} />
                  <Box as="span"   textAlign='left' marginLeft='20px' style={{ color: "rgba(0, 34, 38, 1)", fontSize: '15px', fontWeight: 500, lineHeight: '21px', fontFamily: 'Poppins', }}>
                      {police?.policyNumber || "N/A"}
                  </Box>
                  <div style={{
                                    marginLeft: '10px',   height: '26px', borderRadius: '51px', background: 'rgba(240, 243, 199, 1)', textAlign: 'center', padding: '5px 20px',
                                    fontFamily: 'Poppins', fontSize: '10.69px', fontWeight: 400, lineHeight: ' 16.03px', color: 'rgba(187, 200, 8, 1)',
                                }}>
                                    {translatePolicyRole(police?.rolePolicy) || "N/A"}
                                </div>
                </AccordionButton>
                <AccordionPanel style={{ width: "100%", background: 'rgba(255, 255, 255, 1)', padding: '30px' , borderRadius: "11px" }}>
              <Grid container style={{justifyContent: 'start' , marginBottom :'10px'}}  spacing={2} >
                        <Grid item  > 
                            <div>
                              <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>N° Police</div>
                              {/*<input className={classes.styleInput} name ="numPolice" type="text" value= {police?.policyNumber || "N/A"} disabled/>*/}
                              {renderInputOrSpan(renderAsSpans, police?.policyNumber || "N/A", classes)}
                            </div>
                        </Grid>
                        <Grid item  > 
                            <div>
                              <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Date effet</div>
                              {/*<input className={classes.styleInput} name="dateEffet" value={getDateFromString(police?.subscriptionDate?.toString())} disabled/>*/}
                              {renderInputOrSpan(renderAsSpans, getDateFromString(police?.subscriptionDate?.toString()) || "N/A", classes)}
                            </div>
                        </Grid>
                        <Grid item  > 
                            <div>
                              <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Date expiration</div>
                              {/*<input className={classes.styleInput} name="dateExpiration"  value={getDateFromString(police?.expirationDate?.toString())} disabled/>*/}
                              {renderInputOrSpan(renderAsSpans, getDateFromString(police?.expirationDate?.toString())|| "N/A", classes)}
                            </div>
                        </Grid>
                        <Grid item  > 
                            <div>
                              <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Usage</div>
                              {/*<input className={classes.styleInput} name="usage"  type="text"   value={ police?.policyUsage?.label || "N/A"}  disabled  />*/}
                              {renderInputOrSpan(renderAsSpans, police?.policyUsage?.label || "N/A", classes)}
                            </div>
                        </Grid>
                        
                 
            
                        <Grid item  > 
                          <div>
                          <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Type</div>
                            {/*<input className={classes.styleInput}  name="type" type="text" value={police?.policyType || "N/A"} disabled/>*/}
                            {renderInputOrSpan(renderAsSpans, translatePolicyType(police?.policyType) || "N/A", classes)}
                          </div>
                        </Grid>
                        <Grid item   > 
                          <div >
                            <div className={getLabelClass(renderAsSpans, classes)} style={{marginRight: "40px"}}>Agence</div>
                            {/*<input className={classes.styleInput} name="agence" type="text" value={police?.agency?.code || "N/A"} disabled/>*/}
                            {renderInputOrSpan(renderAsSpans, police?.agency?.code || "N/A", classes)}
                          </div>
                        </Grid>
                        
                </Grid>
                  
                </AccordionPanel>
              </AccordionItem>
         
        ))
      } 
       </>
       }
       </Accordion>
       
    </div>
  );
}


export default PoliceSection;
